"use strict";
module.exports = (config, get, post) => {
	return {
		send: (content, kitAssignmentId) => post("/v2/logisticsnotes/send", {content, kitAssignmentId}),
		list: (search) => get("/v2/logisticsnotes/list", {kitAssignmentId: search.kitAssignmentId, patientId: search.patientId}),
		read: (noteIds, markAsReadForTeam) => post("/v2/logisticsnotes/read", {noteIds, markAsReadForTeam}),
		unread: {
			count: (kitAssignmentId) => get("/v2/logisticsnotes/unread/count", { kitAssignmentId }),
		}
	};
};